import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './accessibility.css';

document.body.classList.add('waflow-low-vision');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
